import './style/projects.css'

// images
import WhatsHapIcon from './img/proj/whatshapicon.jpg';
import AmeIcon from './img/proj/ameicon.png';
import VocalEnhanceIcon from './img/proj/vocalenhancement.png';
import AudioCtxIcon from './img/proj/audiocontexticon.jpg';
import VoodleIcon from './img/proj/voodleicon.png';
import CuddleBitIcon from './img/proj/cuddlebiticon.jpg';
import TeleAffectIcon from './img/proj/teleaffecticon.png';
import HenIcon from './img/proj/henicon.png';

import AMEHeader from './img/proj/ame-header.jpg';
import AMEScreenshots from './img/proj/ame-screenshots.png';
import AudioCtxHeader from './img/proj/audio-context-illustration.png';

import CatGirl from './img/proj/catgirl.jpg';
import Poster1 from './img/proj/hapspeech_poster1.png';
import Poster2 from './img/proj/hapspeech_poster2.png';
import CuddleBitPosee from './img/proj/cuddlebitsposse.jpg';
import HenBanner from './img/proj/henbanner.png';
import CoHereUI from './img/proj/cohere-ui.png';

import {
    Link,
    Switch,
    Route,
    BrowserRouter as Router,
    useRouteMatch,
    useParams
} from 'react-router-dom';

function lockBg(){
    const bg = document.getElementsByTagName("BODY")[0];
    bg.classList.remove("yesScroll")
    bg.classList.add("noScroll")
}

function unlockBg(){
    const bg = document.getElementsByTagName("BODY")[0];
    bg.classList.remove("noScroll")
    bg.classList.add("yesScroll")

}

function Projects() {
    let {path, url} = useRouteMatch();

    return (
        <div className="projectContent">
            <p className="subheader gradient">Projects</p>
            <div className="projectMenu">

                <Link to={`${url}/AME`} className="projectLink">
                    <ProjectIcon
                        img={AmeIcon}
                        title="Apocalypse Made Easy!"
                        desc="Location based mobile survival game">
                        <div className="tag">games</div>
                        <div className="tag">co-op</div>
                        <div className="tag">conversation</div>
                    </ProjectIcon>
                </Link>

                <Link to={`${url}/TeleAffect`} className="projectLink">
                    <ProjectIcon
                        img={TeleAffectIcon}
                        title="Affective Telepresence"
                        desc="Conveying audience emotion">
                        <div className="tag">telepresence</div>
                        <div className="tag">affective computing</div>
                        <div className="tag">augmented intelligence</div>
                    </ProjectIcon>
                </Link>

                <Link to={`${url}/AudioContext`} className="projectLink">
                    <ProjectIcon
                        img={AudioCtxIcon}
                        title="Ambient Context"
                        desc="Conveying environmental context while teleconferencing">
                        <div className="tag">telepresence</div>
                        <div className="tag">machine learning</div>
                        <div className="tag">multimodal</div>
                    </ProjectIcon>
                </Link>

                <Link to={`${url}/WhatsHap`} className="projectLink">
                    <ProjectIcon
                        img={WhatsHapIcon}
                        title="WhatsHap"
                        desc="Haptic phoneme encoder">
                            <div className="tag">haptics</div>
                            <div className="tag">telepresence</div>
                            <div className="tag">conversation</div>
                            <div className="tag">language</div>
                            <div className="tag">multimodal</div>
                    </ProjectIcon>
                </Link>



                <Link to={`${url}/HapSpeech`} className="projectLink">
                    <ProjectIcon
                        img={VocalEnhanceIcon}
                        title="Haptic Speech Enhancement"
                        desc="Feeling speech for enhanced intelligibility">
                        <div className="tag">haptics</div>
                        <div className="tag">speech perception</div>
                        <div className="tag">multimodal</div>
                    </ProjectIcon>
                </Link>



                <Link to={`${url}/Voodle`} className="projectLink">
                    <ProjectIcon
                        img={VoodleIcon}
                        title="Voodle"
                        desc="Vocal doodling to sketch affective robot motion">
                        <div className="tag">affective computing</div>
                        <div className="tag">human-robot-interaction</div>
                        <div className="tag">language</div>
                    </ProjectIcon>
                </Link>

                <Link to={`${url}/CuddleBits`} className="projectLink">
                    <ProjectIcon
                        img={CuddleBitIcon}
                        title="CuddleBits"
                        desc="Huggable furballs for iterative robot design">
                        <div className="tag">affective computing</div>
                        <div className="tag">human-robot-interaction</div>
                    </ProjectIcon>
                </Link>

                <Link to={`${url}/HumanPet`} className="projectLink">
                    <ProjectIcon
                        img={HenIcon}
                        title="Hen the Human Pet"
                        desc="Virtual pet simulator game">
                        <div className="tag">games</div>
                        <div className="tag">narrative</div>
                    </ProjectIcon>
                </Link>


            <Switch>
                <Route exact path={path}>
                </Route>
                <Route path={`${path}/WhatsHap`}>
                    <ProjectPage title="WhatsHap">
                        <p>
                                <span className="secondary"><b>Collaborators:</b> <i>Maurício Fontana de Vargas, Antoine Weill--Duflos, Jeremy Cooperstock</i></span>
                        </p>
                            <p>WhatsHap is an instant messaging app that let's you communicate with people through their skin instead of their ears or eyes.</p>
                                <div className="projectVideo">
                                    <iframe className="video" width="560" height="315" src="https://www.youtube.com/embed/3FqpP26vMQw" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                </div>
                            <p>
                                It may be useful to communicate with others haptically when visual or auditoriy modalities are inadequite. WhatsHap is used to render speech or text as haptic phonemes (speech sounds).
                            </p>
                            <p>WhatsHap follows research by <a href="https://ieeexplore.ieee.org/abstract/document/8816145?casa_token=XzAiPN2EskoAAAAA:ccsviFc-IM3L2MHAtjMV5I3q7KjGfcpHwejOjnMJ8vTAbNRbnUOQWAIZakp6fl9sEUGBu6hGyA" target="_blank" rel="noreferrer">de Vargas et al</a> in phoneme based haptic speech communication.</p>
                            
                            <p>
                                My role on this project:
                                <ul>
                                    <li>Architecting IM system (key technologies: Node.js, Socket.io)</li>
                                    <li>Running a user study</li>
                                    <li>Quantiative and qualitative analysis</li>
                                    <li>Technical paper writing</li>
                                </ul>
                            </p>

                            <p>
                                <b>Relevant publications</b><br></br>
                                <ul>
                                    <li>
                                        <b>Marino, D.</b> de Vargas, M. F., Weill, A., & Cooperstock, J. R. (2021) Conversing  Using  WhatsHap: a Phoneme Based Vibrotactile Messaging Platform. <i>To appear in: IEEE World Haptics Conference Proceedings</i>
                                    </li>
                                    <li>
                                        de Vargas, M. F., <b>Marino, D.</b>, Weill, A., & Cooperstock, J. R. (2021). <a href="https://ieeexplore.ieee.org/abstract/document/9337220?casa_token=bYCqw4Y-1awAAAAA:5IIKEBQa-ucwP1zzzBYoA_aCwLqOiqexZKd3eRp4o61_hENyNjxmNeK2n4CAXuSxr9OZ9rJ_">Speaking Haptically: from Phonemes to Phrases with a Mobile Haptic Communication System. </a><i>IEEE Transactions on Haptics.</i>
                                    </li>
                                </ul>
                                
                            </p>
                    </ProjectPage>
                </Route>

                <Route path={`${path}/AME`}>
                    <ProjectPage title="Apocalypse Made Easy!">
                        <p></p>
                        <img src={AMEHeader} className="projImage"></img>
                        <p>
                            I was a <b>user researcher</b> on <b>Apocalypse Made Easy!</b>, a mobile, location based, cooperative survival game.
                        </p>
                        <p>
                            In Apocalypse Made Easy!, teams of 4-6 people must work together to complete survival training simulations: finding shelter, forming alliances, and foraging for food, with all games physically situated in unique real locations across Vancouver and Kelowna BC.
                        </p>
                        <img src={AMEScreenshots} className="projImage"></img>
                        <br>
                        </br>
                            <i>Screenshots of Apocalypse Made Easy!</i>
                        <p>
                            As a user researcher I:
                        </p>
                            <ul>
                                <li>Conducted quantiative analysis of game telemetry and user segments</li>
                                <li>Lead playtest sessions: utilizing cognitive walkthroughs, think aloud protcol, natural observation, critical incident logging</li>
                                <li>Lead focus groups</li>
                                <li>Created and administered surveys</li>
                                <li>Conducted qualitative thematic analysis on interview and playtest sessions</li>
                            </ul>
                    </ProjectPage>
                </Route>

                    <Route path={`${path}/HapSpeech`}>
                        <ProjectPage title="Haptic Speech Enhancement">
                            <p>
                                <span className="secondary"><b>Collaborators:</b> <i>Karon MacLean, Bryan Gick, Sophy Chu, Hanna Elbaggari, Andrew Yang, Tamara Lottering</i>
                                </span>
                            </p>
                            
                            <img src={CatGirl} className="projImage"></img>
                            <p>
                                Can feeling someone's speech through your skin help you understand them better? This project investigated the degree to which haptic feedback can enhance the intelligibility of speech in noise.
                            </p>
                            <p>
                                In this project, I:
                            </p>
                                <ul>
                                    <li>
                                        Architected the system
                                    </li>
                                    <li>
                                        Supervised a team of undergrad researchers
                                    </li>
                                    <li>
                                        Developed experimental software
                                    </li>
                                    <li>
                                        Conducted quantiative hypothesis testing on experimental data
                                    </li>
                                    <li>
                                        Presented findings and technical report writing
                                    </li>
                                </ul>

                            <p>
                                We utilized a single channel voice coil actuator to deliver haptic feedback to participants similar to the concomitant laryngeal vibrations experienced during voiced speech. We manipulated vibration style, actuator placement, phonemic contrast, and synchrony between speech and haptic stimulation. We found a significant 9% enhancement of speech intelligibility when using the device, and that placement and synchrony did not matter.
                            </p>
                            <hr />

                            <p>
                                <b>Relevant publications</b>
                            </p>
                                <ul>
                                    <li>
                                        <a href="https://asa.scitation.org/doi/abs/10.1121/1.5067937" target="_blank" rel="noreferrer">Single-channel vibrotactile feedback for voicing enhancement in trained and untrained perceivers </a>
                                    </li>
                                    <li>
                                        <a href="https://asa.scitation.org/doi/abs/10.1121/1.5067938" target="_blank" rel="noreferrer">
                                            Testing symmetry of temporal window of integration between vibrotactile and auditory speech information in voiced phoneme perception
                                        </a>
                                    </li>
                                </ul>
                            <hr/>
                            <p>
                                <b>Posters</b>
                                <p>
                                    &nbsp;&nbsp;&nbsp;&nbsp; 
                                    <a href="https://drive.google.com/file/d/11O8d92ozU-SmN0oHXqs7kPfHyrY3TcZF/view" target="_blank" rel="noreferrer">
                                        <img src={Poster1} width="40%"/> 
                                    </a>&nbsp; 
                                    <a href="https://drive.google.com/file/d/1K4lrzAcdAB_Al5OimSKbDckkeDt5W2M4/view" target="_blank" rel="noreferrer">
                                        <img src={Poster2} width="40%" />
                                    </a>
                                </p>
                            </p>
                            <span className="secondary">Presented at the Acoustical Society of America and Canadian Acoustics Acoustics Week in Canada</span>
                            <hr/>
                                <b>Coverage</b>
                                <ul>
                                    <li>
                                       <a href="https://languagesciences.ubc.ca/news-events/announcement-research-news-story-student-news/mar-4-2019-good-vibrations-how-vibrating" target="_blank" rel="noreferrer">UBC language sciences report</a>
                                    </li>
                                    <li>
                                    <a href="https://multipodality.wordpress.com/2018/05/25/episode-3-spin-lab/" target="_blank" rel="noreferrer">multipodality podcast</a>
                                    </li>
                                </ul>

                        </ProjectPage>
                    </Route>

                    <Route path={`${path}/AudioContext`}>
                        <ProjectPage title="Conveying Environmental Context While Teleconferencing">
                            <p>
                                <span className="secondary"><b>Collaborators:</b> <i>Pascal Fortin, Max Henry, Jeremy Cooperstock</i></span>
                            </p>
                            <img src={AudioCtxHeader} className="projImage"></img>

                            <p>
                                This project aims to use visual cues to re-introduce ambient contextual awareness that is otherwise lost while teleconferencing. 
                            </p>

                            <p>
                                This project translates the user's aural soundscape to visual particles that are animated based off the auditory semantics and acoustics of their environment.
                            </p>

                            <p>
                                Below is a presentation I gave for a WIP of this project at the 2020 Animal Crossing Artificial Intelligence Workshop.
                            </p>
                            <div className="projectVideo">
                                <iframe className="video" width="560" height="315" src="https://www.youtube.com/embed/wH8sGC4Y9Qw" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            </div>
                            <p>
                                <b>We are currently running a user study to evaluate this system.</b>
                            </p>
                            <p>
                                My role on this project:
                                <ul>
                                    <li>Contributed to designing and running the study</li>
                                    <li>System development (key technologies: Node.js, webrtc, p5.js)</li>
                                    <li>Contributed to machine learning framework for audio classification</li>
                                </ul>
                            </p>
                        </ProjectPage>
                    </Route>

                    <Route path={`${path}/Voodle`}>
                        <ProjectPage title="Voodle: Vocal Doodling to Sketch Affective Motion">
                            <p>
                                <span className="secondary"><b>Collaborators:</b> <i>Paul Bucci, Oliver Schneider, Karon MacLean</i></span>
                            </p>
                            <div className="projectVideo">
                                <iframe className="video" width="560" height="315" src="https://www.youtube.com/embed/IcUq9PZhN7w" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            </div>
                            <p>
                                Generating believable robot motion is difficult, especially when those animations are meant to convey emotion. Emotion is a natural component of human speech, so we decided to use the speech signal as a basis to generate movement. By doing so, we ground affective representation in the speech signal itself, instead of a cognitive formalism internal to the robot. 
                            </p>
                            <p>
                                We tested this system on a simple 1-degree-of-freedom robot, and created it through co-design, incorporating voice actors, artists, and audio engineers.
                            </p>
                            <p>
                                My role on this project:
                                <ul>
                                    <li>Contributed to designing and running the study</li>
                                    <li>System development (key technologies: Node.js, Arduino)</li>
                                    <li>Technical writing</li>
                                    <li>Presentations</li>
                                </ul> 
                            </p>
                            <hr></hr>
                            <p>Publication</p>
                            <ul>
                                <li><b>Marino, D.</b>, Bucci, P., Schneider, O. S., & MacLean, K. E. (2017, June). <a href="https://dl.acm.org/doi/abs/10.1145/3064663.3064668?casa_token=I6oIn8nxfikAAAAA:059VLZNJUjvt98q6KARiE0F3XVPg_rqrzDaupnuDiYOQCDtEDEJYM5ZQd1FtdvNz--IUinvuG4Ru3A" target="_blank" rel="noreferer">Voodle: Vocal doodling to sketch affective robot motion.</a> In <i>Proceedings of the 2017 Conference on Designing Interactive Systems (pp. 753-765).</i></li>
                            </ul>
                        </ProjectPage>
                    </Route>

                    <Route path={`${path}/CuddleBits`}>
                        <ProjectPage title="CuddleBits">
                            <p>
                                <span className="secondary"><b>Lead Researcher:</b> <i>Paul Bucci</i></span>
                            </p>
                            <img src={CuddleBitPosee} className="projImage"/>
                            <p>
                                The CuddleBits are little zoomorphic furballs that were used as a platform to answer questions in affective human robot interaction.
                            </p>
                            <p>
                                An initiative at the Sensory Perception and Interaction lab was to create a "Cuddle Bot", a large, multi degree-of-freedom (DOF) robot pet that responds to affective touch. But designing such a robot is incredibly complex. <a href="http://paulbucci.ca/" target="_blank">Paul Bucci</a> decided to decompose the multi-DOF CuddleBot into many simple 1-DOF robots--each which can be rapidly iterated and tested upon. These are the CuddleBits.
                            </p>
                            <p>
                                I was a collaborating researcher with the CuddleBits, and used them as a research platform for my own studies. Some activities I did:
                            </p>
                            <ul>
                                <li>iterated on particular cuddlebit form factors</li>
                                <li>ran user studies</li>
                                <li>conducted interviews</li>
                                <li>contributed to report writing</li>
                            </ul>

                            <div className="projectVideo">
                                <iframe className="video" width="560" height="315" src="https://www.youtube.com/embed/8s5rOGOyqvM" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            </div>                            
                            <hr></hr>
                            <p>Relevant publications</p>
                            <ul>
                                <li>Bucci, P., Cang, X. L., Valair, A., <b>Marino, D.</b>, Tseng, L., Jung, M., ... & MacLean, K. E. (2017, May). <a href="https://dl.acm.org/doi/abs/10.1145/3025453.3025774?casa_token=ER0KDB6RamwAAAAA:qyE1_7V6vRPP0Tz3vvNv9CLg5s1E5JUdAb-3HRi_BB-GUfgt-h1lUToNzMB57LDrcz0M_d_XYAI5uQ">Sketching cuddlebits: coupled prototyping of body and behaviour for an affective robot pet.</a> <i>In Proceedings of the 2017 CHI Conference on Human Factors in Computing Systems</i> (pp. 3681-3692).</li>
                                <li><b>Marino, D.</b>, Bucci, P., Schneider, O. S., & MacLean, K. E. (2017, June). <a href="https://dl.acm.org/doi/abs/10.1145/3064663.3064668?casa_token=I6oIn8nxfikAAAAA:059VLZNJUjvt98q6KARiE0F3XVPg_rqrzDaupnuDiYOQCDtEDEJYM5ZQd1FtdvNz--IUinvuG4Ru3A" target="_blank" rel="noreferer">Voodle: Vocal doodling to sketch affective robot motion.</a> In <i>Proceedings of the 2017 Conference on Designing Interactive Systems (pp. 753-765).</i></li>
                                <li>Bucci, P., Cang, X. L., Chun, M., <b>Marino, D.</b>, Schnieder, O., Seifi, H., & MacLean, K. E. (2016). <a href="https://www.cs.ubc.ca/labs/spin/sites/all/local_pdfs/2016cuddlebitsdemo.pdf">CuddleBits: an iterative prototyping platform for complex haptic display.</a> Eurohaptics Demonstration.</li>
                            </ul>
                        </ProjectPage>
                    </Route>

                    <Route path={`${path}/TeleAffect`}>
                        <ProjectPage title="CoHere: Conveying Affect Implicitly">
                            <p>
                                <span className="secondary"><b>Collaborators:</b> <i>Pascal Fortin, Max Henry, Jeremy Cooperstock</i></span>
                            </p>
                            <img src={CoHereUI} className="projImage" />
                            <p>
                                I created a videoconferencing module designed to convey implicit nonverbal feedback from the audience while teleconferencing.
                            </p>
                            <p>
                                <i>
                                    We are in the process of protecting this invention with patent, so I am unable to say much more beyond this.
                                </i>
                            </p>
                            My role on this project:
                            <ul>
                                <li>Technology inception and design</li>
                                <li>Software architecture (key technologies: Node.js, WebRTC, tensorflow.js)</li>
                                <li>Creating and running a mixed methods user study</li>
                            </ul>
                        </ProjectPage>
                    </Route>

                    <Route path={`${path}/HumanPet`}>
                        <ProjectPage title="Hen the Human Pet">

                            <img src={HenBanner} className="projImage" />
                            <p>
                                Hen the Human Pet is a narrative, virtual pet, horror game I made. I did the design, writing, art, and programmed the whole thing in React+JS. I made it because I went insane making a website.
                            </p>
                            <p>
                                <a href="https://nullgarden.itch.io/hen-the-human-pet" target="_blank" rel="noreferer">Play it yourself on itch.io here</a>. (Recommended settings: Chrome on desktop + headphones)
                            </p>
                        </ProjectPage>
                    </Route>

                    <Route path={`${path}/Template`}>
                        <ProjectPage title="Template Title">
                            <p>
                                <span className="secondary"><b>Collaborators:</b> <i>Name, name, name</i></span>
                            </p>
                            <img src="https://cnet4.cbsistatic.com/img/L25_mhBJJSvo4gPDIlVnCDjlLos=/940x0/2019/04/05/dca690a2-c5ae-416a-aade-a758b76bd2c7/skype.jpg" className="projImage" />
                            <p>
                                template
                            </p>
                            <p>
                                <div className="projectVideo">
                                    <iframe className="video" width="560" height="315" src="https://www.youtube.com/embed/3FqpP26vMQw" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                </div>
                            </p>
                        </ProjectPage>
                    </Route>

            </Switch>



        </div>
    </div>

    )
}

function ProjectIcon(props){
    return(
        <div className="projectContainer" onClick={lockBg}>
            <img src={props.img} className="projButtonImage" />
            <div className="innerProjButton">
                <b>{props.title}</b>
                <br></br>
                <span className="secondary">{props.desc}</span><p></p>
                    {props.children}
            </div>
        </div>
    )
}


function ProjectPage(props){
    return(
        <div>
            <Link to='/projects'> 
            <div className="projectPageContainer" onClick={unlockBg}></div>
            </Link>
                
            <div className="projectPageMenu">
                <Link to='/projects'><CloseButton /></Link>
                <div className="subheader projectTitle">{props.title}</div>
                    <div className="projectBody">
                        {props.children}
                    </div>
            </div>
        </div>
    )
}

function CloseButton(){
    return(
        <div className="xButton"
             onClick={unlockBg}>
            x
        </div>
    )
}

export { Projects }